/* eslint-disable react-hooks/exhaustive-deps */
import {
  Container,
  ContainerView,
  DesktopContainer,
  MobileContainer,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { useEffect, useMemo, useState } from "react";
import { FormItem } from "../../components/Form";
import FormButton2 from "../../components/FormCustom2/Button";
import { TitleHistory } from "../../pages/wallet-detail-history/components/transaction-history/styles";
import {
  ContainerTableAddress,
  paginationRender,
  PaginationView,
  TableView,
} from "../../components/Table";
import { deleteAddressBook, getAddressBookList } from "../../services/app";
import { ModalAdd } from "../../components/AddressBooking/ModalAdd";
import { ModalEdit } from "../../components/AddressBooking/ModalEdit";
import { ModalConfirmDelete } from "../../components/AddressBooking/ModalConfirmDelete";
import moment from "moment";
import { Copy } from "../../components/Copy";
import { CopyIcon4 } from "../../components/Icons/CopyIcon";
import EmptyTable from "../../components/EmptyTable";
import EmptyTableMobile from "../../components/EmptyTableMobile";
import AddressItemMobile from "./components/AddressItemMobile";
import { SearchIconGray } from "../../components/Icons/SearchIcon";
import useDebounce from "../../hook/useDebounce";
import { error, success } from "../../Notification";
import { Col, Row } from "antd";
import FormInput from "../../components/FormCustom2/Input";
import { Fragment } from "react";

export default function AddressBook(props) {
  const { T, loading, setLoading } = useApp();
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState(null);
  const [filterData, setFilterData] = useState({
    keyword: "",
  });

  const openDelete = (record) => {
    setSelected(record);
    setIsOpenDelete(true);
  };
  const openEdit = (record) => {
    setSelected(record);
    setIsOpenEdit(true);
  };

  const openAddAddress = () => {
    setIsOpenAdd(true);
  };
  const onCloseDelete = () => {
    setIsOpenDelete(false);
    setSelected(null);
  };
  const handleDelete = async () => {
    if (loading || !selected) return;
    setLoading(true);
    try {
      const res = await deleteAddressBook({
        id: selected.id,
      });
      if (res?.data?.status) {
        success(T("Your wallet address has been deleted successfully."));
        loadData();
      } else {
        error(T("Failed to edit your wallet address. Please try again."));
      }
      onCloseDelete();
    } catch (e) {
      onCloseDelete();
      error(T("Failed to edit your wallet address. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  const debounceFilterData = useDebounce(filterData, 500);

  const columns = [
    {
      title: T("Name"),
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (val, record) => (
        <span
          className="text-base font-normal hover:underline hover:underline-offset-1 hover:text-aia-red-500"
          onClick={() => openEdit(record)}
        >
          {val}
        </span>
      ),
    },
    {
      title: T("Wallet address"),
      dataIndex: "address",
      key: "address",
      align: "center",
      render: (val, record) =>
        val ? (
          <div className="w-[150px] mx-auto">
            <Copy
              textStyle={{ fontWeight: 400, fontSize: 16 }}
              textCss={
                "hover:underline hover:underline-offset-1 hover:!text-aia-red-500"
              }
              textAction={() => openEdit(record)}
              cutText={true}
              splitFont={5}
              numDot={3}
              text={val}
              icon={<CopyIcon4 />}
            />
          </div>
        ) : (
          <></>
        ),
    },
    {
      title: T("Modified at"),
      dataIndex: "updated_time",
      key: "updated_time",
      align: "center",
      render: (val) => (
        <span className="text-base font-normal">
          {moment(val).format("YYYY/MM/DD")}
        </span>
      ),
    },
    {
      title: T("Action"),
      dataIndex: "id",
      key: "id",
      align: "center",
      render: (val, record) => (
        <div className="flex justify-center" onClick={() => openDelete(record)}>
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.02344 3.5C8.38379 2.48046 9.35613 1.75 10.4991 1.75C11.642 1.75 12.6143 2.48046 12.9747 3.5"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M17.9376 5.25H3.0625"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M16.4779 7.4375L16.0754 13.4742C15.9205 15.7973 15.8431 16.9588 15.0862 17.6669C14.3293 18.375 13.1652 18.375 10.837 18.375H10.1604C7.83215 18.375 6.66805 18.375 5.91117 17.6669C5.15428 16.9588 5.07685 15.7973 4.92198 13.4742L4.51953 7.4375"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M8.3125 9.625L8.75 14"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M12.6875 9.625L12.25 14"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
      ),
    },
  ];

  useEffect(() => {
    loadData({
      page,
      size: 10,
      ...debounceFilterData,
    }).then();
  }, [page, debounceFilterData]);

  useEffect(() => {
    setPage(1);
  }, [debounceFilterData]);

  const loadData = async (params) => {
    setLoading(true);
    let result = await getAddressBookList(params);
    if (result?.data?.status) {
      const data = result?.data?.data?.rows || [];
      setTotal(result?.data?.data?.count || 0);
      setRows(data);
    }
    setLoading(false);
  };

  const rowsGroupByName = useMemo(() => {
    const grouped = [];
    rows.forEach((row) => {
      const firstLetter = row.name.charAt(0).toUpperCase();
      if (!grouped[firstLetter]) {
        grouped[firstLetter] = [];
      }
      grouped[firstLetter].push(row);
    });
    const result = Object.keys(grouped).map((key) => ({
      letter: key,
      rows: grouped[key],
    }));
    result.sort((a, b) => a.letter.localeCompare(b.letter));
    return result;
  }, [rows]);

  const renderItemGroup = (group) => {
    const groupRows = group?.rows;
    return (
      <>
        <div className="text-[#535353] text-[13px]">{group?.letter}</div>
        {groupRows?.length &&
          groupRows.map((item) => (
            <Col key={item.id} span={24}>
              <AddressItemMobile
                item={item}
                onDelete={openDelete}
                onEdit={openEdit}
              />
            </Col>
          ))}
      </>
    );
  };

  const renderItemMobile = () => {
    return (
      <div className="mt-3 bg-white rounded-[20px] p-5">
        <Row gutter={[0, 16]}>
          {rowsGroupByName?.length ? (
            rowsGroupByName?.map((item) => 
              <Fragment key={item.letter}>
                {renderItemGroup(item)}
              </Fragment>
          )
          ) : (
            <div className="w-full flex justify-center pt-[50px]">
              <EmptyTableMobile T={T} />
            </div>
          )}
        </Row>
      </div>
    );
  };

  return (
    <Container>
      <ContainerView>
        <DesktopContainer>
          <TitleHistory>{T("Address book")}</TitleHistory>
        </DesktopContainer>
        <MobileContainer>
          <div className="relative flex flex-col gap-3">
            <TitleHistory
              style={{ marginTop: 0, width: "unset", textAlign: "left" }}
            >
              {T("Address book")}
            </TitleHistory>
            <FormButton2
              onClick={() => openAddAddress()}
              className="primary2"
              height={50}
              style={{
                width: "100%",
                padding: "4px 12px",
              }}
            >
              {T("Add address")}
            </FormButton2>
            <div>
              <FormItem className="search">
                <FormInput
                  value={filterData.keyword}
                  className="!rounded-[16px] input-sot"
                  onChange={(e) =>
                    setFilterData({
                      ...filterData,
                      keyword: e.target.value,
                    })
                  }
                  placeholder={T("Enter name")}
                  prefix={
                    <span className="bg-white">
                      <SearchIconGray />
                    </span>
                  }
                />
              </FormItem>
            </div>
          </div>
        </MobileContainer>
        <>
          <DesktopContainer>
            <ContainerTableAddress>
              <div className="flex justify-between items-center">
                <div className="flex justify-start gap-4 w-full">
                  <FormItem label={T("Name")} style={{ minWidth: "300px" }}>
                    <FormInput
                      value={filterData.keyword}
                      className="!rounded-[16px] input-sot"
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          keyword: e.target.value,
                        })
                      }
                      placeholder={T("Enter name")}
                      prefix={
                        <span className="bg-white">
                          <SearchIconGray />
                        </span>
                      }
                    />
                  </FormItem>
                </div>
                <FormButton2
                  onClick={() => openAddAddress()}
                  className="primary2"
                  height={50}
                  style={{
                    minWidth: 169,
                    padding: "4px 12px",
                  }}
                >
                  {T("Add address")}
                </FormButton2>
              </div>
              <TableView
                rowKey="id"
                locale={{ emptyText: <EmptyTable T={T} /> }}
                scroll={{ x: true }}
                pagination={false}
                dataSource={rows}
                columns={columns}
              />
            </ContainerTableAddress>
          </DesktopContainer>
          <MobileContainer>{renderItemMobile()}</MobileContainer>
        </>
        {total / 10 > 1 ? (
          <PaginationView
            current={page}
            pageSize={10}
            onChange={(p, ps) => {
              setPage(p);
            }}
            total={total}
            itemRender={paginationRender}
          />
        ) : null}
      </ContainerView>

      {isOpenAdd && (
        <ModalAdd
          title={"Add new address"}
          onSubmit={() => {
            setIsOpenAdd(false);
            loadData();
          }}
          onClose={() => setIsOpenAdd(false)}
        />
      )}
      {isOpenEdit && (
        <ModalEdit
          title={"Edit address"}
          item={selected}
          onSubmit={() => {
            setIsOpenEdit(false);
            loadData();
          }}
          onClose={() => setIsOpenEdit(false)}
        />
      )}
      {isOpenDelete && (
        <ModalConfirmDelete
          title={"Delete wallet address"}
          item={selected}
          onSubmit={() => handleDelete()}
          onClose={() => onCloseDelete()}
        />
      )}
    </Container>
  );
}
